'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  var index = value.indexOf('\n', fromIndex);

  while (index > fromIndex) {
    if (value.charAt(index - 1) !== ' ') {
      break;
    }

    index--;
  }

  return index;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-parse/lib/locate/break.js
// module id = 239
// module chunks = 96961042003272 139266963665775